import { render, staticRenderFns } from "./ManipulationModal.vue?vue&type=template&id=64c365da&"
import script from "./ManipulationModal.vue?vue&type=script&lang=js&"
export * from "./ManipulationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports